import { ISutochnoPilot } from '../../types/sutochnoPilot';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const LOAD_SUTOCHNO_PILOT_SUCCESS = 'sutochno_pilot/load_success' as const;

export const loadSutochnoPilotSuccess = actionGenerator<typeof LOAD_SUTOCHNO_PILOT_SUCCESS, ISutochnoPilot>(
  LOAD_SUTOCHNO_PILOT_SUCCESS,
);

export type TLoadSutochnoPilotSuccess = ReturnType<typeof loadSutochnoPilotSuccess>;
